// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19l7b","col":"styles_col__Nkos7","actions":"styles_actions__3J42a","conflict":"styles_conflict__2VhTz"};